import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
	state:{       
		global_loading:false,     //state里面放置的是数据源
		scene_item:{},
		user:{
			userId:"602def61-005d-11ee-91d8-005056b86db5",
			userName:"harry",
			organizeid:"45facc0a-1211-11ec-80ad-005056b86db5"		
		},
		is_phone:false,
		my_role:[],
		public_role:[],
		muti_agent_list:[],
		park_file_list:[],
		ip_address:"",
		api: 'https://pbl.cocorobo.cn/api/pbl/',
		apiM: 'https://pbl.cocorobo.cn/api/mongo/',
		knowledgeBaseAip:"https://r2rapi.cocorobo.cn/file/",
		// apiM: 'http://localhost:7003/api/mongo/',
		muti_agent_data:{},
		// api: 'http://localhost:7003/api/pbl/',
		// yWebsocket:"ws://localhost:1234",//
		yWebsocket:"wss://yjs.cocorobo.cn",
		templateJson: {}
	},
	actions:{           

	},
	mutations:{ 
		set_global_loading(state,item){
			state.global_loading = item;
		},
		set_muti_agent_data(state,item){
			state.muti_agent_data = item;
		},
    set_change_scene(state,item){
			state.scene_item = item;
		},
		set_user(state,item){
			state.user = item;
		},
		set_is_phone(state,item){
			state.is_phone = item;
		},
		set_my_role(state,item){
			state.my_role = item;
		},
		set_public_role(state,item){
			state.public_role = item;
		},
		set_muti_agent_list(state,item){
			state.muti_agent_list = item;
		},
		set_park_file_list(state,item){
			state.park_file_list = item;
		},
		set_ip_address(state,item){
			state.ip_address = item;
		},
		set_template_json(state,item){
			state.templateJson = item
		}
	}
})
export default store

